'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./pagination.css');

var _ = require('../../');

var _models = require('../../models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoPagination = function (_Component) {
    _inherits(GeckoPagination, _Component);

    function GeckoPagination() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoPagination);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoPagination.__proto__ || Object.getPrototypeOf(GeckoPagination)).call.apply(_ref, [this].concat(args))), _this), _this.btns = [{
            icon: 'angle-left',
            ariaLabel: 'Previous',
            handler: function handler() {
                _this.props.pagination.changePage(_this.props.pagination.current_page - 1);
            },
            disabledWhen: function disabledWhen() {
                return _this.props.pagination.current_page === 1;
            }
        }, {
            icon: 'angle-right',
            ariaLabel: 'Next',
            handler: function handler() {
                _this.props.pagination.changePage(_this.props.pagination.current_page + 1);
            },
            disabledWhen: function disabledWhen() {
                return _this.props.pagination.current_page === _this.props.pagination.total_pages;
            }
        }], _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GeckoPagination, [{
        key: 'renderTotal',
        value: function renderTotal() {
            return _react2.default.createElement(
                'span',
                null,
                'Found ',
                this.props.pagination.total_items || 0,
                ' results.'
            );
        }
    }, {
        key: 'renderSummary',
        value: function renderSummary() {
            if (this.props.pagination.total_items) {
                return _react2.default.createElement(
                    'span',
                    null,
                    'Showing page ',
                    this.props.pagination.current_page,
                    ' of ',
                    this.props.pagination.total_pages,
                    '.'
                );
            }
            return null;
        }
    }, {
        key: 'renderBtns',
        value: function renderBtns() {
            if (this.props.pagination.total_pages > 1) {
                return _react2.default.createElement(_.GeckoBtns, { items: this.btns, group: true });
            }
            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.pagination) return null;
            return _react2.default.createElement(
                'div',
                { className: 'gecko-ui-pagination' },
                _react2.default.createElement(
                    'span',
                    { className: 'results-text' },
                    this.renderTotal(),
                    '\xA0',
                    this.renderSummary()
                ),
                this.renderBtns()
            );
        }
    }]);

    return GeckoPagination;
}(_react.Component);

GeckoPagination.propTypes = {
    pagination: _propTypes2.default.shape(_models.GeckoPaginationModel)
};

exports.default = GeckoPagination;